import { render, staticRenderFns } from "./freightTemplate.vue?vue&type=template&id=1f10294a&scoped=true"
import script from "./freightTemplate.vue?vue&type=script&lang=js"
export * from "./freightTemplate.vue?vue&type=script&lang=js"
import style0 from "./freightTemplate.vue?vue&type=style&index=0&id=1f10294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f10294a",
  null
  
)

export default component.exports